import type {
  Milestone,
  ActionPlan,
  Task,
} from '@getaccept/dsr-shared-new/src/mutual-action-plan/types/action-plan';
import { GraphQLFetchPolicy } from '@getaccept/lib-shared-new/src/graphql/graphql-fetch-policy';
import type { LoadMilestoneDto } from '@getaccept/dsr-shared-new/src/api/mutual-action-plan/types/load-milestone-dto';
import type { TaskStatus } from '@getaccept/dsr-shared-new/src/mutual-action-plan/types/enums/task-status';
import { apolloClient } from '../../../apollo';
import { ActionPlanQueries } from '../graphql/action-plan.queries';
import { ActionPlanMutations } from '../graphql/action-plan.mutations';

export class ActionPlanService {
  static async load(): Promise<ActionPlan[]> {
    const {
      data: {
        getActionPlans: { actionPlans },
      },
    } = await apolloClient.query({
      query: ActionPlanQueries.load,
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return actionPlans;
  }

  static async loadMilestones({
    actionPlanId,
    offset,
    limit,
  }: LoadMilestoneDto): Promise<Milestone[]> {
    const {
      data: {
        getMilestones: { milestones },
      },
    } = await apolloClient.query({
      query: ActionPlanQueries.loadMilestones,
      variables: { actionPlanId, offset, limit },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return milestones;
  }

  static async loadMilestone(actionPlanId: string, milestoneId: string): Promise<Milestone> {
    const {
      data: { milestone },
    } = await apolloClient.query({
      query: ActionPlanQueries.loadMilestone,
      variables: { actionPlanId, milestoneId },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return milestone;
  }

  static async loadTask(actionPlanId: string, milestoneId: string, taskId: string): Promise<Task> {
    const {
      data: { task },
    } = await apolloClient.query({
      query: ActionPlanQueries.loadTask,
      variables: { actionPlanId, milestoneId, taskId },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return task;
  }

  static async updateTaskStatus(
    actionPlanId: string,
    milestoneId: string,
    taskId: string,
    status: TaskStatus
  ): Promise<void> {
    await apolloClient.mutate({
      mutation: ActionPlanMutations.updateTask,
      variables: { actionPlanId, milestoneId, taskId, payload: { status } },
    });
  }
}
